/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	AfterViewChecked,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	HostListener,
	inject,
	input,
	OnChanges,
	ViewChild
} from '@angular/core';
import * as d3 from 'd3';

import {DonutStatistics} from '@intocare/interfaces';

@Component({
	selector: 'ic-donut-chart',
	template: '<div #donut></div>',
	styleUrls: ['./donut.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DonutChartComponent implements AfterViewChecked, OnChanges {
	values = input<DonutStatistics[]>([]);
	label = input<string>();
	cdRef = inject(ChangeDetectorRef);
	el = inject(ElementRef);

	private width = this.el.nativeElement.clientWidth;
	private radius = this.width / 2;
	private innerRadius = this.width / 2.6;
	private colors = d3.scaleOrdinal(d3.schemeCategory10);
	private total = 0;
	private arc = d3.arc().innerRadius(this.innerRadius).outerRadius(this.radius);
	private pie = d3
		.pie()
		.value((d: any) => d.value)
		.sort(null);

	@ViewChild('donut', {static: true}) donut: ElementRef;

	@HostListener('window:resize')
	onResize() {
		this.cdRef.detectChanges();
	}

	ngOnChanges() {
		if (!this.label()) {
			this.total = 0;
			for (const value of this.values()) {
				this.total += value.value;
			}
		}

		this.draw();
	}

	ngAfterViewChecked() {
		setTimeout(() => {
			this.respondToWidth();
			this.draw();
		});
	}

	private draw() {
		this.donut.nativeElement.innerHTML = '';

		d3.select(this.donut.nativeElement)
			.style('position', 'relative')
			.style('display', 'flex')
			.style('justify-content', 'center')
			.append('label')
			.html(`${this.label() || this.total}`)
			.attr('class', 'donut-chart-total')
			.style('line-height', `${this.width}px`)
			.style('font-size', `${this.width / 5}px`);

		const svg = d3
			.select(this.donut.nativeElement)
			.append('svg')
			.attr('class', 'pie')
			.attr('width', this.width)
			.attr('height', this.width);

		const g = svg.append('g').attr('transform', `translate(${this.radius},${this.radius})`);

		g.selectAll('path')
			.data(this.pie(this.values() as any))
			.enter()
			.append('path')
			.attr('d', this.arc as any)
			.attr('class', (d: any) => d.data.class || '')
			.attr('fill', (_, i) => this.colors(`${i}`));
	}

	private respondToWidth() {
		this.width = this.el.nativeElement.clientWidth;
		this.radius = this.width / 2;
		this.innerRadius = this.width / 2.6;
		this.arc = d3.arc().innerRadius(this.innerRadius).outerRadius(this.radius);
	}
}
